var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid px-4"},[_c('div',{staticClass:"row"},[(_vm.tabsLists.includes(_vm.$route.name) === true)?_c('tab-group',{attrs:{"routes":_vm.routes}}):_vm._e(),_c('div',{staticClass:"col-12 pl-0"},[_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }